import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import Pillars from "@/components/site/Pillars";
import Rooms from "@/components/site/Rooms";
import Gallery from "@/components/site/Gallery";
import BoardTransferSection from "@/components/site/BoardTransferSection";
import Services from "@/components/site/Services";
import Facilities from "@/components/site/Facilities";
import Dining from "@/components/site/Dining";
import Testimonial from "@/components/site/Testimonial";
import LocationSection from "@/components/site/LocationSection";
import Faq from "@/components/site/Faq";
import ContactCta from "@/components/site/ContactCta";
import Footer from "@/components/site/Footer";
import WhatsAppFloat from "@/components/site/WhatsAppFloat";

export default function Home() {
  return (
    <div className="bg-sand-50 text-ink font-sans antialiased min-h-screen">
      <Navbar />
      <main>
        <Hero />
        <Pillars />
        <Rooms />
        <Gallery />
        <BoardTransferSection />
        <Services />
        <Facilities />
        <Dining />
        <Testimonial />
        <LocationSection />
        <Faq />
        <ContactCta />
      </main>
      <Footer />
      <WhatsAppFloat />
    </div>
  );
}
